import { render } from "./DashboardIndex.vue?vue&type=template&id=31522c8b&scoped=true"
import script from "./DashboardIndex.vue?vue&type=script&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&lang=js"

import "./DashboardIndex.vue?vue&type=style&index=0&id=31522c8b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31522c8b"]])

export default __exports__